export default "__VITE_ASSET__CSxAAhVw__"